import React from "react";
import Button from "../customComponents/Button";
import { useNavigate } from "react-router-dom";

const TransportationModal = ({ onClose, transportationData }) => {
  const navigate = useNavigate();

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    return new Date(dateString).toLocaleDateString();
  };
  const handleEditClick = () => {
    navigate("/add-transportation", {
      state: {
        transportData: transportationData,
        isEdit: true,
      },
    });
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white rounded-t-lg shadow-lg w-full h-[50vh] md:h-[75vh] overflow-y-auto p-6 border-b mt-auto">
        {/* Header */}
        <div className="flex justify-between items-center mb-6 border-b">
          <h2 className="text-xl font-semibold">Vehicle Details</h2>
          <div className="flex space-x-4 items-center">
            <Button
              type="primary"
              label="Edit Vehicle"
              onClick={handleEditClick}
            />
            <a
              onClick={onClose}
              className="text-gray-500 hover:text-black cursor-pointer"
            >
              <span className="material-symbols-outlined">close</span>
            </a>
          </div>
        </div>
        <div className="mt-2 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 pb-6 border-b">
        {transportationData.vehiclename && (
          <div className="mt-7">
            <div className="font-semibold">Vehicle Name</div>
            <div className="mt-2">
              <div>{transportationData.vehiclename}</div>
            </div>
          </div>
        )}
        {transportationData.vehicletype && (
          <div className="mt-7">
            <div className="font-semibold">Vehicle Type</div>
            <div className="mt-2">
              <div>{transportationData.vehicletype}</div>
            </div>
          </div>
        )}
        {transportationData.actype && (
          <div className="mt-7">
            <div className="font-semibold">AC/Non AC</div>
            <div className="mt-2">
              <div>{transportationData.actype}</div>
            </div>
          </div>
          )}
          {transportationData.noofseats && (
          <div className="mt-7">
            <div className="font-semibold">No. of Seats</div>
            <div className="mt-2">
              <div>{transportationData.noofseats}</div>
            </div>
          </div>
          )}
          {transportationData.city && (
          <div className="mt-7">
            <div className="font-semibold">Source</div>
            <div className="mt-2">
              <div>{transportationData.city}</div>
            </div>
          </div>
          )}
          {transportationData.destination && (
          <div className="mt-7">
            <div className="font-semibold">Destination</div>
            <div className="mt-2">
              <div>{transportationData.destination}</div>
            </div>
          </div>
          )}
          {transportationData.interstatecharges && (
          <div className="mt-7">
            <div className="font-semibold">InterState Charges</div>
            <div className="mt-2">
              <div>{transportationData.interstatecharges}</div>
            </div>
          </div>
          )}
          {transportationData.localinr && (
          <div className="mt-7">
            <div className="font-semibold">Local</div>
            <div className="mt-2">
              <div>{transportationData.localinr}</div>
            </div>
          </div>
          )}
          {transportationData.basekm && (
          <div className="mt-7">
            <div className="font-semibold">Base KM</div>
            <div className="mt-2">
              <div>{transportationData.basekm}</div>
            </div>
          </div>
          )}
          {transportationData.basechargeinr && (
          <div className="mt-7">
            <div className="font-semibold">Base Charge (INR)</div>
            <div className="mt-2">
              <div>{transportationData.basechargeinr}</div>
            </div>
          </div>
          )}
          {transportationData.additionalkm && (
          <div className="mt-7">
            <div className="font-semibold">Additional KM</div>
            <div className="mt-2">
              <div>{transportationData.additionalkm}</div>
            </div>
          </div>
          )}
          {transportationData.additionalchargeinr && (
          <div className="mt-7">
            <div className="font-semibold">Additional Charge (INR)</div>
            <div className="mt-2">
              <div>{transportationData.additionalchargeinr}</div>
            </div>
          </div>
          )}
          {transportationData.priceperhead && (
          <div className="mt-7">
            <div className="font-semibold">Price Per Head</div>
            <div className="mt-2">
              <div>{transportationData.priceperhead}</div>
            </div>
          </div>
          )}
          {transportationData.interstatetax && (
          <div className="mt-7">
            <div className="font-semibold">Interstate Tax</div>
            <div className="mt-2">
              <div>{transportationData.interstatetax}</div>
            </div>
          </div>
          )}
          {transportationData.batainr && (
          <div className="mt-7">
            <div className="font-semibold">BATA</div>
            <div className="mt-2">
              <div>{transportationData.batainr}</div>
            </div>
          </div>
          )}
          {transportationData.parking && (
          <div className="mt-7">
            <div className="font-semibold">Parking</div>
            <div className="mt-2">
              <div>{transportationData.parking}</div>
            </div>
          </div>
          )}
          {transportationData.overheadprice && (
          <div className="mt-7">
            <div className="font-semibold">Overhead Price</div>
            <div className="mt-2">
              <div>{transportationData.overheadprice}</div>
            </div>
          </div>
          )}
          {transportationData.seasonstart && (
          <div className="mt-7">
            <div className="font-semibold">Season</div>
            <div className="mt-2">
              <div>{formatDate(transportationData.seasonstart)} -{" "}
              {formatDate(transportationData.seasonend)}</div>
            </div>
          </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default TransportationModal;
